import React from 'react'
import { Flex, Text } from 'pcln-design-system'
import PropTypes from 'prop-types'

const ExpressDealHeader = ({ headerText }) => {
  return (
    <Flex px='12px' py='10px' color='primary.base' borderRadius='lg' rounded='top'>
      <Text bold fontSize={[0, 1]}>
        EXPRESS DEAL
      </Text>

      {!!headerText && (
        <Text ml='auto' fontSize={[0, 1]} bold>
          {headerText}
        </Text>
      )}
    </Flex>
  )
}

ExpressDealHeader.propTypes = {
  headerText: PropTypes.string,
}

export { ExpressDealHeader }
